import React from 'react';
import GenericErrorUI from '../../../components/common/GenericErrorUI';
import SuperUserLoanPageUI from '../../../templates/SuperUserLoanPageUI.js'
import LRTableActionsUI from '../../../widgets/layout/LRTableActionsUI'
import IconButtonUI from '../../../widgets/action/IconButtonUI'
import EmptyListUI from '../../../widgets/output/EmptyListUI.js'
import VehicleTypeUpdateModalSF from '../../../components/superUser/loan/VehicleTypeUpdateModalSF';
import SpinnerComponentUI from '../../../components/common/SpinnerComponentUI';
import CardUI from '../../../widgets/layout/CardUI';
import ProjectsNavUI from '../../../components/superUser/loan/ProjectsNavUI.js';

const VehicleTypeListPageUI = ({ context, errorList, loan, onRefreshClick,
  vehicleTypeList, filteredVehicleTypeList,
  updateVehicleTypeMode, onVehicleTypeUpdateClick, onVehicleTypeUpdateCancel
}) =>
  <SuperUserLoanPageUI context={context} className='pg_su_loan_a_lst'
    backLink={`/su/loans${loan && (loan.status === 'closed' ? '/closed' : (loan.status === 'disbursed' ? '/disbursed' : ''))}`}
    headerText={loan ? (loan.accountName + ' ' + (loan.loanName || '')) : 'Loan'}
    centered={!loan || !errorList} loan={loan} page='projects' dimension='w768'
  >
    {
      (!loan || !errorList) &&
      <SpinnerComponentUI />
    }
    {
      errorList && errorList.length > 0 &&
      <GenericErrorUI error={errorList[0]} />
    }
    {
      loan &&
      <LRTableActionsUI location='top'
        left={
          <span className='g_flex_left g_flex_h'>
            <IconButtonUI icon='icon-refresh' onClick={onRefreshClick} />
            <IconButtonUI icon='icon-plus' onClick={onVehicleTypeUpdateClick} />
            <span className='g_m_left_100 g_large'><b>Vehicle Types</b></span>
          </span>
        }
        right={<span />}
      />
    }
    {
      loan &&
      <ProjectsNavUI loan={loan} page='vehicleTypes' />
    }
    {loan && loan.vehicleTypeList.length !== 0 && (
      <CardUI>
        <table>
          <thead>
            <tr>
              <th>Vehicle Type</th>
              <th>Count</th>
            </tr>
          </thead>
          <tbody>
            {loan.vehicleTypeList.map((vehicleType, i) => (
              <tr key={i}>
                <td>{vehicleType.vehicleTypeName}</td>
                <td className='g_text_right'>{vehicleType.vehicleCount}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </CardUI>
    )}
    {loan &&
      loan.vehicleTypeList.length === 0 && (
        <div className='g_m_top_50'>
          <EmptyListUI
            context={context}
            createEnabled={false}
            createDisabledMessageLabel='No Vehicle Types'
          />
        </div>
      )
    }
    {
      loan && <VehicleTypeUpdateModalSF context={context}
        loan={loan} onRefreshClick={onRefreshClick} vehicleTypeList={filteredVehicleTypeList}
        updateMode={updateVehicleTypeMode} onCancelUpdate={onVehicleTypeUpdateCancel}
      />
    }
  </SuperUserLoanPageUI>

export default VehicleTypeListPageUI;
